<template>
    <b-modal
        v-model="modal"
        :title="isEdit ? 'Edit' : 'Add'"
        hide-footer
        centered
        @show="setData"
        @hidden="resetData"
    >
        <b-form @submit.prevent="onSubmit">
            <b-form-group label="AWS Account ID">
                <b-form-input
                    v-model="form.awsAccountId"
                    minlength="12"
                    maxlength="12"
                    :disabled="isEdit"
                    required
                ></b-form-input>
            </b-form-group>
            <b-form-group label="AWS Account Name">
                <b-form-input
                    v-model="form.awsAccountName"
                    required
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Access Key ID">
                <b-form-input
                    v-model="form.accessKeyId"
                    required
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Secret Access Key">
                <b-form-input
                    v-model="form.secretAccessKey"
                    required
                    :type="showSecretAccessKey ? 'text' : 'password'"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Show Secret Access Key">
                <b-form-checkbox
                    v-model="showSecretAccessKey"
                    switch
                ></b-form-checkbox>
            </b-form-group>
            <b-form-group>
                <b-form-checkbox v-model="form.isShared" switch required
                    >isShared</b-form-checkbox
                >
            </b-form-group>
            <b-button type="submit" block variant="primary">Save</b-button>
        </b-form>
    </b-modal>
</template>

<script>
import {
    addPayerAwsAccount,
    editPayerAwsAccount,
} from '@/services/aws.service';

const INIT_FORM_DATA = {
    awsAccountId: '',
    awsAccountName: '',
    accessKeyId: '',
    secretAccessKey: '',
    isShared: false,
};
export default {
    name: 'AddOrEditPayerModal',
    props: {
        value: {
            type: Boolean,
            required: true,
            default: false,
        },
        currentData: {
            type: [Object, null],
            required: false,
            default() {
                return null;
            },
        },
    },
    computed: {
        modal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        isEdit() {
            return !!this.currentData;
        },
    },
    data() {
        return {
            form: {
                ...INIT_FORM_DATA,
            },
            showSecretAccessKey: false,
        };
    },
    methods: {
        setData() {
            if (this.isEdit) {
                this.form.awsAccountId = this.currentData.awsAccountId;
                this.form.awsAccountName = this.currentData.awsAccountName;
                this.form.isShared = this.currentData.isShared;
            }
        },
        resetData() {
            this.form = { ...INIT_FORM_DATA };
        },
        onSubmit() {
            const saveFunc = this.isEdit ? this.editData : this.addData;
            saveFunc()
                .then(() => {
                    this.$bvToast.toast(`Save success!`, {
                        title: 'Success',
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant: 'success',
                        solid: false,
                        toaster: 'b-toaster-top-center',
                    });
                    this.$emit('onDone');
                    this.modal = false;
                })
                .catch((e) => {
                    const data = e.response?.data || {};

                    this.form.isCreateNewUser = !data.isCreatedUser;
                    const message = data.message || 'An error occurred!';
                    this.$bvToast.toast(message, {
                        title: 'Error',
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant: 'danger',
                        solid: false,
                        toaster: 'b-toaster-top-center',
                    });
                });
        },
        async addData() {
            return addPayerAwsAccount(this.form);
        },
        async editData() {
            return editPayerAwsAccount(this.currentData.id, this.form);
        },
    },
};
</script>

<style scoped></style>
